import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import Lobby from "@/pages/Lobby";
import AuthPage from "@/pages/AuthPage";
import VipPage from "@/pages/VipPage";
import AdminPage from "@/pages/AdminPage";
import { Header } from "@/components/Header";
import { BottomNav } from "@/components/BottomNav";
import { StoreModal } from "@/components/store/StoreModal";
import { SuccessModal } from "@/components/SuccessModal";

function Protected({ children, admin }) {
  const { user, ready } = useApp();
  if (!ready) return <div className="min-h-screen" />;
  if (!user) return <Navigate to={admin ? "/admin/login" : "/login"} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/admin/login" replace />;
  return children;
}

function PlayerShell({ children }) {
  return (
    <Protected>
      <Header />
      {children}
      <BottomNav />
      <StoreModal />
      <SuccessModal />
    </Protected>
  );
}

function App() {
  return (
    <div className="App grain">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<AuthPage />} />
            <Route path="/admin/login" element={<AuthPage admin />} />
            <Route path="/" element={<PlayerShell><Lobby /></PlayerShell>} />
            <Route path="/vip" element={<PlayerShell><VipPage /></PlayerShell>} />
            <Route path="/admin" element={<Protected admin><AdminPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
      </AppProvider>
    </div>
  );
}

export default App;
